import { render } from "./BarChart.vue?vue&type=template&id=63de7a1b&ts=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"symbiosy-vue-chatjs/src/charts/BarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63de7a1b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63de7a1b', __exports__)) {
    api.reload('63de7a1b', __exports__)
  }
  
  module.hot.accept("./BarChart.vue?vue&type=template&id=63de7a1b&ts=true", () => {
    api.rerender('63de7a1b', render)
  })

}


export default __exports__